var allH = [];
var tallestP = 0;
function resizeWindow(){
	setTimeout(function() {
		equalize();
	}, 500);
}
function scrollDown(){
}

// tab promo
var tabPromo = $('.promo-tab');
var tabPromoSize = tabPromo.outerWidth();
var boxPromoVillas = $('.promotion-widget .promo-box');
var sizebox = boxPromoVillas.width();

setTimeout(() => {
	$('.top-content').css('opacity','1');
	$('.intro-content').css('opacity','1');
	$('#header').css('opacity','1');
}, 200);

function popInHardcoded(){	
	tabPromo.addClass('open');
	// box promo info
	boxPromoVillas.addClass('close');
	boxPromoVillas.css({
		'left' : - sizebox
	});	
	$('.promo-tab').click(function(){
		
		if($(this).hasClass('open')){
			$(this).css({
				'left' : - tabPromoSize
			});
			setTimeout(function(){
				boxPromoVillas.css({
					'left' : '0',
					'opacity' : '1'
				});
				$('.shadow-box').addClass('open-box');
			}, 300);
		}
		$('.promo-toggle').addClass('open');		
	});	
	$('.promo-toggle').click(function(){
		if($(this).hasClass('open')){
			
			boxPromoVillas.css({
				'left' : - sizebox,
				'opacity' : '0'
			});
			$('.shadow-box').removeClass('open-box');
			setTimeout(function(){
				tabPromo.css({
					'left' : '0'
				});
			}, 300);			
		}
	});
}
function navisEmailSignup(formID) {

	$.post(site_url + 'ajax/emailsignup.php',$("#" + formID).serialize(), function(data){
		if(data.error) {
			$("#email-error").html(data.msg);

		} else {
			//ga('send', 'event', 'form', 'click', 'specials');
			$("#"+formID).html('<p>Thank You</p>');

		}
	},'json');

}
function pressH() {
	allH = [];
	$('.press-item').each(function(){
		$(this).find('.title').css('height','auto');
		allH.push($(this).find('.title').height());
	});
	tallestP = allH.reduce(function(a,b){
		return a > b ? a : b;
	},{});
	$('.press-item').each(function(){
		$(this).find('.title').css('height',tallestP + 10 +'px');
	});
}

$(window).load(function(){
	resizeWindow();
	pressH();
});
//Function Tabs page /policies
$(function(){
    $( ".policies-block" ).tabs({
		event: "mouseover"
	  });
});

function _get_form_token(){
	$.get(
		site_url + '/ajax/functions.php?operation=_get_form_token',
		function(resp) {
			$("input[name=_token][type=hidden]").each( function(){
				this.value = resp
			})		
		}		
	);
}

$(document).ready(function () {
	_get_form_token();
	// const pathname = window.location.pathname;
	// if(pathname.indexOf('/givethanks')>-1){
	// 	$('input[name=email_address]').val('reservations'+Math.floor(Math.random() * 90)+'@lafayetteparkhotel.com');
	// }
	//sign up badge
	$('#signupCta').click(function(){
		$('#signupContainer').addClass('open')
	});
	$('#signupClose').click(function(){
		$('#signupContainer').removeClass('open')
	});



	//Call function with browser is resized.
	$(window).resize(function(){
		resizeWindow();
		pressH();
	  });

	  if($('.instagram-block').length > 0){
		instagramAjaxFeed('lafayetteparkhotel',5,'#home-instagram__gallery',320,'.instagram-block');
	  }
    
    //Acts when scroll down page.
    $(window).scroll(function (event) {
		var top = $(document).scrollTop();
		if ( $('#home').length > 0 && !$('header').addClass('scroll') ) {
			if (top > 50) {
				$('header').addClass('scroll');
			} else {
				$('header').removeClass('scroll');
			}
		}
		if($('#default').length > 0 || $('#accommodations-overview').length > 0) {			
			if (top > 424) {
				$('.sub-menu').addClass('fixed-nav');
				$('#content #top-content .notice').css('top',227);
			} else {
				$('.sub-menu').removeClass('fixed-nav');
				$('#content #top-content .notice').css('top',163);
			}
		}
		if($('#home').length > 0 ) {
			if (top > 80) {
				$('.notice-payment').fadeOut();
			} else {
				$('.notice-payment').fadeIn();
			}
		}
		if($('#content-popin').length > 0 && $('#home').length > 0) {
			if (top > 270) {
				$('#content-popin').fadeIn();
			} else {
				//$('#content-popin').fadeOut();				
			}
		}		
		var windowWidth = $(window).width();
		if(windowWidth >= 768 || windowWidth <=1024){
			if($('#default').length > 0 ) {			
				if (top > 200) {
					$('.sub-menu').addClass('fixed-nav');
					$('#content #top-content .notice').css('top',227);
				} else {
					$('.sub-menu').removeClass('fixed-nav');
					$('#content #top-content .notice').css('top',163);
				}
			}	
		}	
	});

	//check alert
	setTimeout(function(){
		if($('.topalert').length > 0){
			$('body').addClass('withalert');
		}
	},600);
	
	$('a[href*="synxis.com/"]').each(function(i){
    	var bookingLink = $(this);
        var href = bookingLink.attr('href');
        bookingLink.attr('href', AppendNavisKeywordToURL(href));
    });

	// View chart functionality
	$('.view-chart').click(function(){
		$('.capacity-chart').slideToggle();
		$('.view-chart').toggleClass('open');
	});
	$('.sym-inline-list').addClass('clearfix');

	function showArticleInfo(){
		$(this).parent().find('p').slideDown();
		$(this).addClass('open');
		$(this).unbind('click');
		$(this).click(hideArticleInfo);
	}
	function hideArticleInfo(){
		$(this).parent().find('p').slideUp();
		$(this).removeClass('open');
		$(this).unbind('click');
		$(this).click(showArticleInfo);
	}

	//pop in left .special-popin
	$('.special-popin__call').click(function(){
		let nextContent = $(this).next();
		nextContent.addClass('active');
	})
	$('.special-popin__content .closepopin').click(function(){
		let nextContent = $(this).parent();
		nextContent.removeClass('active');
	})
	$('.special-popin__content a').click(function(){
		ga('send', 'event', 'popup', 'click', 'staylonger-btn');
	})
	
	
	popInHardcoded();
	// $('#content .notice p').slideUp();
	$('#content .notice .title').click(function(event) {
		if($(this).hasClass('clicked')){
			$(this).removeClass('clicked');
			$('#content .notice p').slideUp();
		}else{
			$(this).addClass('clicked');
			$('#content .notice p').slideDown();
		}
	});

	//Careers dropdowns
	$('article.drop-down .title').click(showArticleInfo);

	// Book benefits
	$('.book-benefits .title').click(function(){
		$('.book-benefits').toggleClass('hide-ben', 400);
		$('.book-benefits .benefits').toggleClass('hide-ben', 500);
	});

	$('.read-more-quad').click(function(){
		$(this).next().slideToggle();
		$(this).hide();		
	});
	$('.read-less-quad').click(function(){
		$(this).closest('.full-content').slideToggle();				
		$(this).closest('.full-content').prev().show('3000');
	});
	//Open Pop In when is in Dinning Page
	if($('#default.dining').length > 0) {
		$('#content-popin').removeClass("hide-right-popin");
		$('.box-content-popin').addClass("open");
		$('.arrow').addClass("open");
	}


	


	if($('#home').length > 0 ) {
		$('#content .notice p').slideUp();
		$('.top-content .sym-slide').height($(window).height());
		$('.header-img').css('max-width',$(window).width());
		$( "#primary-nav" ).hover(
		  function() {
			var top = $(document).scrollTop();
			if (top < 50) {
		    // $( '#header' ).addClass( 'scroll' );
		    }
		  }, function() {
			var top = $(document).scrollTop();
			if (top < 50) {
		    // $( '#header' ).removeClass( 'scroll' );
		    }
		  }
		);
		
		//Home page scroll down arrow. If present.
		$('.arrow-home').click(function(event) {
		    $('body, html').animate({
		        scrollTop: $(window).height()-$('header').outerHeight()*2},
		        800, 'easeOutExpo');
		});
		$('#reasons-rotate').slick({
			dots: true,
			fade: true,
			speed: 5000,  			
			appendDots: '.numbers',
			accessibility:false,
			customPaging : function(slider, i) {
				var thumb = $(slider.$slides[i]).data();
				return '<a>0'+(i+1)+'</a>';
			}
		});

		
		setTimeout(function() {
		    $('.numbers-holder').height($('.top-reasons .desc').height());
	    }, 500);

	}	
	// if($('.rooms-suites').length > 0 ) {
	// 	$('.room').css('height',$('.room').width()*0.8+'px')
	// }
	$('p, .group').each(function() {
	    var $this = $(this);
	    if($this.html().replace(/\s|&nbsp;/g, '').length == 0)
	        $this.remove();
	});
	// $( "#primary-nav li" ).each(function( index ) {
	// 	if ($(this).children('ul').length > 0) {
	// 		$(this).addClass('dropdown');
	// 	}
	// 	if($(this).children('li a').hasClass('active') && $(this).hasClass('dropdown')) {
	// 		$(this).addClass('open');
	// 	}
	// });
	$('.book-trigger').on('click', function(e){
		$('.booking-holder').fadeIn();
	});
	
	$('.close-booking').on('click', function(e){
		$('.booking-holder').fadeOut();
	});
	$( "#accordion" ).accordion({
		icons: false,
		active: false,
		collapsible: true	
	});
	$('#accordion .list a').click(function(event) {
		var parentID = $(this).parent().parent().attr("id");
		var target = $(this).attr("href");
		$('#accordion .list a').removeClass("active");
		$(this).addClass("active");
		$("#"+parentID+" .desc").fadeOut(300);
		setTimeout(function() {
			$("#"+parentID+" "+target).fadeIn(300);
		}, 301);
		return false;
	});
	
	$('.room .image-icon').on('click', function(e){
		var target = $(this).parent().parent().attr("id");
		$("#"+target+" .slides").fadeToggle();
	});
	
	$('.included').on('click', function(e){
		var target = $(this).parent().parent().parent().attr("id");
		$("#"+target+" ul").slideToggle();
	});
	

	//Slick Slider
	$('.sym-slides').slick();



	// Reasons to stay
	$('.reasons-rotate').slick({
		dots: true,
		fade: true,
		appendDots: '.numbers',
		accessibility:false,
		customPaging : function(slider, i) {
			var thumb = $(slider.$slides[i]).data();
			return '<a>0'+(i+1)+'</a>';
		}
	});

	setTimeout(function() {
	    $('.numbers-holder').height($('.top-reasons .desc').height());
    }, 500);
	// internal reasons to stay
     $('.reasons-rotate-2').slick({
		dots: true,
		fade: true,
		accessibility:false,
		appendDots: '.numbers',
		customPaging : function(slider, i) {
		var thumb = $(slider.$slides[i]).data('title');
		return '<div class="number-title">0'+(i+1)+'</div>'+'<a>'+thumb+'</a>';
		}
	});
	setTimeout(function() {
	   $('.numbers-holder').height($('.top-reasons .desc').height());
	}, 500);

	//Event Tracking
    $('.book-now').on('click', function () {
         ga('send', 'event', 'reservations', 'click', 'book now');
    });
    $('.bookNow').on('click', function () {
         ga('send', 'event', 'header widget', 'click', 'book now');
    });
	
	$(".datepicker-promo").datepicker({
		minDate: 0,
		numberOfMonths: [2,1],
		beforeShowDay: function(date) {
			var date1 = $.datepicker.parseDate($.datepicker._defaults.dateFormat, $("#CheckIn").val());
			var date2 = $.datepicker.parseDate($.datepicker._defaults.dateFormat, $("#CheckOut").val());
			return [true, date1 && ((date.getTime() == date1.getTime()) || (date2 && date >= date1 && date <= date2)) ? "dp-highlight" : ""];
		},
		onSelect: function(dateText, inst) {
			var date1 = $.datepicker.parseDate($.datepicker._defaults.dateFormat, $("#CheckIn").val());
			var date2 = $.datepicker.parseDate($.datepicker._defaults.dateFormat, $("#CheckOut").val());
            var selectedDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, dateText);
            
            if (!date1 || date2) {
				$("#CheckIn").val(dateText);
				$("#CheckOut").val("");
                $(this).datepicker();
            } else if( selectedDate < date1 ) {
                $("#CheckOut").val( $("#CheckIn").val() );
                $("#CheckIn").val(dateText);
                $(this).datepicker();
            } else {
				$("#CheckOut").val(dateText);
                $(this).datepicker();
			}
		}
	});
	//Check in and check out datepicker for booking engine
	$( "#CheckIn" ).datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		changeMonth: true,
		numberOfMonths: 2,
		minDate: 0,
		onSelect: function( selectedDate ) {
			getDate = $(this).datepicker('getDate');
        	newDate = new Date(getDate.getTime());
        	newDate.setDate(newDate.getDate() + 3);
			$( "#CheckOut" ).datepicker( "setDate", newDate );
			$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
		}
	});
	$( "#CheckOut" ).datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		changeMonth: true,
		numberOfMonths: 2,
		onSelect: function( selectedDate ) {
			$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
		}
	});

	// Remove atr
	$('#third-nav').removeAttr('aria-labelledby');
	$('#third-nav').removeAttr('aria-label');

		// VALIDATE COUNTRY FIELD REQUIRED IN EXIT INTENT
		//$.validator.addMethod("valueNotEquals", function(value, element, arg){
			//return arg !== value;
		   //}, "Value must not equal arg.");
		  
		// configure your validation
		/* $("#bio_ep form").validate({
			rules: {
			 SelectName: { valueNotEquals: "" }
			},
			messages: {
			 SelectName: { valueNotEquals: "Please select an item!" }
			}  
		}); VALIDATION PLUGIN IS NOT LOADED */

		$('.press-new-carousel').slick({
			accessibility: false,
			slidesToShow: 3,
			slidesToScroll:1,
			centerMode:true,
			focusOnSelect:true,
			adaptiveHeight:true,
			responsive: [
				{
				  breakpoint: 1000,
				  settings: { 
					slidesToShow : 1,
					centerMode:false
				  }
				}
			]

		})
		$('.sym-slides').slick({
			accessibility: true,
			fade:true
		});

});

//single form function
function Gratitude(){
	document.getElementsByClassName('text-top')[0].classList.add('submitted')
}

(function(){
	// Sign up form footer functionality

	if (document.getElementById("ot-sdk-btn") && document.getElementById("tertiary-navigation")) {
        document.getElementById("tertiary-navigation").appendChild(document.getElementById("ot-sdk-btn"))
    }

	let footerSignUp = document.querySelector('.signup');
	let signUpCta = document.querySelector('.cleanliness-badge.signup-badge');
	
	footerSignUp.style.cursor = 'pointer';
	footerSignUp.addEventListener('click', () => simulateClick(signUpCta));

	function simulateClick(elem) {
		const event = new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window
        });
		elem.dispatchEvent(event);
	}

		function pageMoveUrl() {
		if (window.location.href === "https://www.lafayetteparkhotel.com/#first-email-signup") {
			window.scrollBy(0, -250);
			}
		}

	window.addEventListener("load", pageMoveUrl);
//custom popin 
		let topBanner = document.querySelector('.custom-popin .top-popin');
		let bottomBanner = document.querySelector('.custom-popin .bottom-popin');
		let closeBottomBanner = document.querySelector('.custom-popin .bottom-popin__close');
	
		document.addEventListener('DOMContentLoaded', function(){
			if( topBanner && topBanner.classList.contains('no-visible') ) {
				console.log(topBanner);
				topBanner.classList.remove('no-visible');
			}
	
			if( topBanner ){
				topBanner.addEventListener('click', function(){
					if( bottomBanner && bottomBanner.classList.contains('no-visible')  ){
						topBanner.classList.add('no-visible');
						bottomBanner.classList.remove('no-visible'); 
					}
				});
			}
	
			if( closeBottomBanner && bottomBanner ){
				closeBottomBanner.addEventListener('click', function (){
					bottomBanner.classList.add('no-visible');
				});
			}
	
		});

}());

